import { FormInstance } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { InstallationSchema, OrderModelForm } from "types/installation";
import { validateDate } from "utils/global";
import { getSalutationFromGender } from "utils/global/installationHelper";
import TogglingInput from "./TogglingInput";

type Props = {
  defaultValue: InstallationSchema;
  form?: FormInstance<OrderModelForm>;
};

export function ContactDetails({ defaultValue, form }: Props) {
  const { t } = useTranslation();

  const { customer, additionalInformation, setupDate, pickupDate } =
    defaultValue;

  useEffect(() => {
    form?.setFieldsValue({
      barrierDetailsSetupDate: defaultValue.setupDate,
    });
  }, [defaultValue.setupDate]);

  useEffect(() => {
    form?.setFieldsValue({
      barrierDetailsPickupDate: defaultValue.pickupDate,
    });
  }, [defaultValue.pickupDate]);

  const {
    gender,
    firstName,
    lastName,
    email,
    companyName,
    streetAndHouseNumber: contactStreetAndHouseNumber,
    cityAndZipCode,
    notes,
    telephoneNumber,
    street,
    houseNumber,
    city,
    zipCode,
  } = customer;

  return (
    <div className="flex-1">
      <h5 className="underline">{t("orders:customer")}:</h5>

      <TogglingInput
        name="additionalSalutation"
        label={t("orders:salutation")}
        originalValue={gender ? getSalutationFromGender(gender) : "-"}
        updatedValue={additionalInformation?.additionalSalutation}
      />

      <TogglingInput
        name="additionalFirstName"
        label={t("orders:firstName")}
        originalValue={firstName}
        updatedValue={additionalInformation?.additionalFirstName}
      />

      <TogglingInput
        name="additionalLastName"
        label={t("orders:lastName")}
        originalValue={lastName}
        updatedValue={additionalInformation?.additionalLastName}
      />

      <TogglingInput
        name="additionalEmail"
        label={t("orders:email")}
        originalValue={email}
        updatedValue={additionalInformation?.additionalEmail}
      />

      <TogglingInput
        name="additionalCompanyName"
        label={t("orders:companyName")}
        originalValue={companyName}
        updatedValue={additionalInformation?.additionalCompanyName}
      />

      <TogglingInput
        name="additionalContactStreetAndHouseNumber"
        label={t("orders:streetAndHouseNumber")}
        originalValue={
          contactStreetAndHouseNumber || `${street} ${houseNumber}`
        }
        updatedValue={
          additionalInformation?.additionalContactStreetAndHouseNumber
        }
      />

      <TogglingInput
        name="additionalContactCityAndZipCode"
        label={t("orders:cityAndZipCode")}
        originalValue={cityAndZipCode || `${city} ${zipCode}`}
        updatedValue={additionalInformation?.additionalContactCityAndZipCode}
      />

      <TogglingInput
        name="additionalNotes"
        label={t("orders:notes")}
        originalValue={notes || "-"}
        updatedValue={additionalInformation?.additionalNotes}
      />

      <TogglingInput
        name="additionalTelephoneNumber"
        label={t("orders:telephoneNumber")}
        originalValue={telephoneNumber}
        updatedValue={additionalInformation?.additionalTelephoneNumber}
      />

      <TogglingInput
        name="barrierDetailsSetupDate"
        label={t("orders:barrierDetails.setupDate")}
        originalValue={setupDate}
        updatedValue={undefined}
        placeholder="YYYY-MM-DD"
        rules={[
          {
            validator: validateDate,
          },
        ]}
      />
      <TogglingInput
        name="barrierDetailsPickupDate"
        label={t("orders:barrierDetails.pickupDate")}
        originalValue={pickupDate}
        updatedValue={undefined}
        placeholder="YYYY-MM-DD"
        rules={[
          {
            validator: validateDate,
          },
        ]}
      />
    </div>
  );
}
